import { useMutation, useQueryClient } from '@tanstack/react-query';
import CourseService from '../Services/courses/CourseService';
import { toast } from 'sonner';
import { GET_COURSES_QUERY_KEY } from '../queries/useGetCourses';
import { SHOW_CHAPTER_DETAILS_QUERY_KEY } from '../queries';
export const useCourseMutations = () => {
  const queryClient = useQueryClient();

  const createCourseMutation = useMutation({
    mutationFn: ({ courseData, imageFile }) => CourseService.createNewCourse(courseData, imageFile),
    onSuccess: (response) => {
      queryClient.invalidateQueries([GET_COURSES_QUERY_KEY]);
      toast.success("Cours créé avec succès");
    },
    onError: (error) => {
      toast.error(`Échec de la création : ${error.message}`);
    },
  });

  const updateCourseMutation = useMutation({
    mutationFn: ({ id, courseData, imageFile }) => CourseService.updateCourseDetails(id, courseData, imageFile),
    onSuccess: () => {
      queryClient.invalidateQueries([GET_COURSES_QUERY_KEY]);
      toast.success("Cours mis à jour avec succès");
    },
    onError: (error) => {
      toast.error(`Échec de la mise à jour : ${error.message}`);
    },
  });

  const deleteCourseMutation = useMutation({
    mutationFn: (id) => CourseService.deleteCourse(id),
    onSuccess: (response) => {
      if (response.success) {
        queryClient.invalidateQueries([GET_COURSES_QUERY_KEY]);
        toast.success("Cours supprimé avec succès");
      } else {
        toast.error("Une erreur s'est produite lors de la suppression du cours.");
      }
    },
    onError: (error) => {
      toast.error(`Échec de la suppression : ${error.message}`);
    },
  });

  const uploadAudioMutation = useMutation({
    mutationFn: (audioData) => CourseService.uploadAudio(audioData),
    onSuccess: (response) => {
      toast.success("Audio upload started successfully");
      queryClient.invalidateQueries({ queryKey: [SHOW_CHAPTER_DETAILS_QUERY_KEY] });
    },
    onError: (error) => {
      toast.error(`Audio upload failed: ${error.message}`);
    },
  });

  const deleteAudioMutation = useMutation({
    mutationFn: (trackId) => CourseService.deleteAudio(trackId),
    onSuccess: (response) => {
      toast.success("Audio track deleted successfully");
      queryClient.invalidateQueries({ queryKey: [SHOW_CHAPTER_DETAILS_QUERY_KEY] });
    },
    onError: (error) => {
      toast.error(`Failed to delete audio track: ${error.message}`);
    },
  });

  const deleteMuxAssetMutation = useMutation({
    mutationFn: (uploadId) => CourseService.deleteMuxAsset(uploadId),
    onSuccess: (response) => {
      toast.success("Asset deleted successfully");
    },
    onError: (error) => {
      toast.error(`Failed to delete asset: ${error.message}`);
    },
  });
  
  return {
    createCourseMutation,
    updateCourseMutation,
    deleteCourseMutation,
    uploadAudioMutation,
    deleteMuxAssetMutation,
    deleteAudioMutation,
  };
};
